import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';

import { En } from './En/En';
import { Ru } from './Ru/Ru';
import { Cn } from './Cn/Cn';
import { Ar } from './Ar/Ar';

function App() {
    const history = useHistory();
    const location = useLocation();

    return (
        <div className='page'>
            <Switch>
                <Route exact path='/'>
                    <En
                        history={history}
                    />
                </Route>

                <Route exact path='/ru'>
                    <Ru
                        history={history}
                    />
                </Route>

                <Route exact path='/cn'>
                    <Cn
                        history={history}
                    />
                </Route>

                <Route exact path='/ar'>
                    <Ar
                        history={history}
                    />
                </Route>
            </Switch>
        </div>
    );
};

export default App;
